import { render } from "./DetailsAlarms.vue?vue&type=template&id=44f3cc8e"
import script from "./DetailsAlarms.vue?vue&type=script&lang=js"
export * from "./DetailsAlarms.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__